import React from "react";
import "./MultiDropdown.scss";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: 0,
    minWidth: 120,
    width: "-webkit-fill-available",
  },
}));

const MultiDropdown = ({ selectData }: { selectData: any }) => {
  const classes = useStyles();
  const [boxData, setBoxData] = React.useState<any>([]);
  const [values, setValues] = React.useState<string[]>([]);
  React.useEffect(() => {
    setBoxData([...selectData?.data]);
  }, [selectData?.data]);
  
  React.useEffect(() => {
    if (selectData?.data === "") {
      setValues([]);
    }
  }, [selectData?.data]);
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
   (selectData?.data === "") ?  setValues([]) : setValues(event.target.value as string[]);
    
  };
 
  return (
    <div className="multipleSelect_wrapper">
      <div className="cover">
        <FormControl className={classes.formControl}>
          <Select
            className={`border-${selectData?.borderColor} `}
            name={selectData?.name}
            disabled={selectData?.disabled}
            onChange={(e) => {
              selectData?.onChange(e);
              handleChange(e);
            }}
            value={values}
            
            displayEmpty
            multiple
            input={<Input />}
            renderValue={
              values?.length > 0 && values?.length < 7
               ? (selected) => `${values?.length} Selected`
               //? (selected) => (selected as string[]).join(",")
                : () => selectData?.placeHolder
            }
          >
            {boxData &&
              boxData.map((item: any, i: any) => (
                <MenuItem key={i} value={item}>
                  <Checkbox
                    checked={values.indexOf(item) > -1 && values.indexOf(item) < 6}
                    color={"primary"}
                  />
                  {item}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default MultiDropdown;

